/* ===========================
IMPORTS
=========================== */
import React from 'react';
import PropTypes from 'prop-types';
// IMPORT - ELEMENTS
import Loader from '../Elements/Loader';
import { IconSearch } from '../Elements/Icons';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class ModalFirmware extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * Main constructor of Component
   */
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      meta: {},
      page: 1,
      limit: 10,
      search: '',
      loading: false,
      focus: null,
    };

    this.get = this.get.bind(this);
    this.onClickNext = this.onClickNext.bind(this);
    this.onClickPrev = this.onClickPrev.bind(this);
    this.onSearchUpdate = this.onSearchUpdate.bind(this);
    this.onClickRow = this.onClickRow.bind(this);
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.props.updateLoadingModal(false);
    this.get();
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   */
  searchTimeout = null;

  /**
   * @param {object} params
   * @param {function} callback
   * @param {function} failback
   */
  get(params, callback, failback) {
    this.setState({
      loading: true,
    }, () => {
      // Make initial request
      const defaultPayload = {
        page: this.state.page,
        limit: this.state.limit,
      };

      if (this.state.search && this.state.search.length > 0) {
        defaultPayload.search = this.state.search;
      }

      ModalFirmware.request(
        (params || defaultPayload),
        // callback
        (response) => {
          if (callback) {
            callback(response);
          } else if (response.firmwares) {
            this.setState({
              data: response.firmwares,
              meta: response.meta,
              loading: false,
            }, () => {
              // refocus on original input element
              if (this.state.focus) {
                document.getElementById(this.state.focus).focus();
              }
            });
          }
        },
        // failback
        (error) => {
          if (failback) {
            failback(error);
          } else {
            this.setState({
              loading: false,
            });
          }
        },
      );
    });
  }

  /**
   * @param {function} callback
   * @param {function} failback
   */
  static request(params, callback, failback) {
    let query = '';
    if (params && Object.keys(params).length > 0) {
      Object.keys(params).map((key) => {
        query += `${key}=${params[key]}&`;
        return key;
      });
      query = `?${query}`;
    }

    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/firmwares${query}`,
      'get',
      null,
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      // failback
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
   * @param {object} payload
   * @param {function} callback
   * @param {function} failback
   */
  requestPut(payload, callback, failback) {
    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/bundles/${this.props.data.id}`,
      'put',
      JSON.stringify(payload),
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      // failback
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
   */
  onClickPrev() {
    this.setState((prevState) => ({
      page: prevState.page - 1,
    }), () => {
      this.get();
    });
  }

  /**
   */
  onClickNext() {
    this.setState((prevState) => ({
      page: prevState.page + 1,
    }), () => {
      this.get();
    });
  }

  /**
   * @param {Event} event
   */
  onSearchUpdate(event) {
    this.setState({
      search: event.target.value,
      focus: event.target.id,
    }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.get();
      }, 350);
    });
    event.preventDefault();
  }

  /**
   * @param {Event} event
   * @param {integer} id
   */
  onClickRow(event, id) {
    this.props.handleSubmit(true);

    if (this.props.data.firmware
      && this.props.data.firmware.id
      && (this.props.data.firmware.id === id)) {
      this.requestPut(
        {
          firmware_id: null,
        },
        // callback
        () => {
          this.props.handleSubmitSuccess();
        },
        // failback
        () => {
          this.props.handleSubmit(false);
        },
      );
    } else {
      this.requestPut(
        {
          firmware_id: id,
        },
        // callback
        () => {
          this.props.handleSubmitSuccess();
        },
        // failback
        () => {
          this.props.handleSubmit(false);
        },
      );
    }

    event.preventDefault();
  }

  /* ===========================
  RENDER
  =========================== */
  /**
   * Main table render
   */
  renderTable() {
    return (
      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th>Firmware Name</th>
            </tr>
          </thead>
          <tbody>
            {(this.state.loading)
              ? (<tr><td className="text-center" colSpan="2"><Loader /></td></tr>)
              : (
                <>
                  {(this.state.data.length > 0)
                    ? (this.state.data.map((row) => (
                      <tr key={`data-${row.id}`}>
                        <td>
                          {(this.props.data.firmware
                              && this.props.data.firmware.id
                              && this.props.data.firmware.id === row.id)
                            ? (<button type="button" onClick={(e) => this.onClickRow(e, row.id)} disabled={this.props.submitted} className="btn btn-danger btn-block">{(this.props.submitted) ? '...' : (<i className="fa fa-close" />)}</button>)
                            : (<button type="button" onClick={(e) => this.onClickRow(e, row.id)} disabled={this.props.submitted} className="btn btn-success btn-block">{(this.props.submitted) ? '...' : (<i className="fa fa-check" />)}</button>)}
                        </td>
                        <td>{row.name}</td>
                      </tr>
                    )))
                    : (<tr><td colSpan="2">No Results</td></tr>)}
                </>
              )}
          </tbody>
        </table>
      </div>
    );
  }

  /**
   * Main render
   */
  render() {
    return (
      <div>
        {(!this.props.loading)
          ? (
            <div>
              {(this.props.data.firmware && this.props.data.firmware.id
                ? (
                  <div className="Tables-Current">
                    <div className="btn-group" role="group">
                      <button type="button" aria-label="click-row" onClick={(e) => this.onClickRow(e, this.props.data.firmware.id)} disabled={this.props.submitted || this.state.loading} className="btn btn-secondary"><i className="fa fa-close" /></button>
                      <button type="button" disabled={this.props.submitted || this.state.loading} onClick={this.onClickPrev} className="btn btn-secondary">{this.props.data.firmware.name}</button>
                    </div>
                  </div>
                )
                : null
              )}

              <div className="Tables">
                <div className="Tables-Search">
                  <div className="form-group">
                    <input id="Modal-Table-Search" onChange={this.onSearchUpdate} disabled={this.state.loading || this.props.submitted} type="search" className="form-control" placeholder="Search" value={this.state.search} />
                    <IconSearch />
                  </div>
                </div>
              </div>

              <div className="Tables-Control">
                <div className="row">
                  <div className="col col-12">
                    <div className="Tables-Control-Pagination float-left">
                      <div className="btn-group" role="group">
                        <button type="button" disabled={this.props.submitted || this.state.loading || this.state.data.length === 0 || this.state.page === 1} onClick={this.onClickPrev} className="btn btn-info">Prev</button>
                        <button type="button" disabled={this.props.submitted || this.state.loading || this.state.data.length === 0 || ((this.state.meta.total - (this.state.page * this.state.limit)) <= 0)} onClick={this.onClickNext} className="btn btn-info">Next</button>
                      </div>
                    </div>

                    {(!this.state.loading)
                      ? (
                        <div className="Tables-Control-Showing">
                          {(this.state.meta.total)
                            ? (
                              <span className="Tables-Control-Showing-Results">
                                Showing
                                {(this.state.data.length > 0)
                                  ? (((this.state.page - 1) * this.state.limit) + 1)
                                  : 0}
                                -
                                {((this.state.data.length > 0)
                                  // eslint-disable-next-line max-len
                                  ? (((this.state.page - 1) * this.state.limit) + this.state.data.length)
                                  : 0)}
                                {' '}
                                of
                                {this.state.meta.total}
                              </span>
                            )
                            : null}
                        </div>
                      )
                      : null}

                  </div>
                </div>
              </div>
              <div className="Tables-Data">
                {(this.renderTable())}
              </div>
            </div>
          )
          : ''}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
ModalFirmware.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  submitted: PropTypes.bool,
  updateLoadingModal: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleSubmitSuccess: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default ModalFirmware;
